import { CartErrorsEnum } from '@src/domains/cart';

const VERIFICATION_ERRORS = [CartErrorsEnum.TARIFF_VERIFICATION_VALIDATION_NOT_FULFILLED];

/**
 * Checks if there's a validation error in cart for a specific tariff
 */
export const getCartTariffVerificationError = (
  cartErrors: Record<string, string>,
  tariffUnitIndex: number,
  verificationPosition: number,
  verificationValuesLength: number,
  tariffTypePosition?: number,
): boolean => {
  if (!cartErrors || tariffTypePosition === undefined) return false;
  const key = `tariffs[${tariffTypePosition}].verificationValues[${
    tariffUnitIndex * verificationValuesLength + verificationPosition
  }].value`;

  return VERIFICATION_ERRORS.includes(cartErrors[key] as CartErrorsEnum);
};
